import { Id, Observer, UserRole } from '@nextforce/api'
import { QueryClient } from '@tanstack/react-query'
import { produce } from 'immer'
import keys from './keys'

export async function removeUserFromCache(
  client: QueryClient,
  id: Id,
  role?: UserRole,
  companyId?: Id
) {
  const userListData = client.getQueryData<Observer[]>(
    keys.list(companyId, role)
  )

  if (userListData) {
    const index = userListData.findIndex(c => c.id === id)

    if (index < 0) {
      return
    }

    await client.cancelQueries({ queryKey: keys.list(companyId, role) })
    client.setQueryData<Observer[]>(
      keys.list(companyId, role),
      produce(userListData, updatedData => {
        updatedData.splice(index, 1)
      })
    )
  }
}
